// import { EXCECUTE_PROCCESS_ACTION_END } from "../modules/workflow/actions/actiontype";

export const SYSTEM_ID = 3;
export const SYSTEM_MENU_ID = 1;
export const INSURED_TYPE_INDIVIDUAL = 5;
export const QUOTE_CONVERTED_TO_POLICY = 2;
export const QUOTE_ACTON_STATUS_OPEN = 1;
export const BUSINESS_TYPE_AGENT = 1;
export const BUSINESS_TYPE_BROKER = 2;
export const BUSINESS_TYPE_DIRECT = 3;
export const VISA_EMIRATE_ABU_DHABI = 11;
export const VISA_EMIRATE_AL_AIN = 313;
export const VISA_EMIRATE_DUBAI = 13;
export const DOCUMENT_TYPE_NEW_POLICY = 8;
export const DOCUMENT_TYPE_ENDORSEMENT = 9;
export const DOCUMENT_TYPE_REQUEST = 372;
export const DOCUMENT_TYPE_RENEWAL = 10;


export const SALARY_BAND_NO_SALARY = 25;
export const SALARY_BAND_LESS_THAN_4000 = 22;
export const SALARY_BAND_BETWEEN_4001_1200 = 23;
export const SALARY_BAND_GREATER_THAN_12000 = 24;
export const VISA_TYPE_NEW_ENTRY = 179;
export const VISA_TYPE_RESIDENT = 181;
export const GENDER_MALE = 190;
export const GENDER_FEMALE = 191;
export const CHARGES_HAAD_PENALTY = 38;
export const FACILITATION_CHARGES = 37;
export const QUOTE_STAGE_OPEN = "Open";
export const QUOTE_STAGE_CONFIRMED = 3;
export const QUOTE_STAGE_CONFIRMED_VALUE = "Confirmed";
export const STAGE_OPEN = 1;
export const ENDORSEMENT_STATUS_OPEN = 8;
export const ENDORSEMENT_STATUS_APPROVED = 10;
export const ACTION_STATUS_POLICY_ISSUED = 2;
export const QUOTE_CONVERTED_TO_POLICY_STATUS = "Policy Issued";
export const YES = "Y"
export const NO = "N"
export const REGION_EMIRATE_NE = 185;
export const REGION_EMIRATE_DUBAI = 186;
export const REGION_EMIRATE_ABUDHABI = 187;

export const RELATION_PRINCIPAL = "Principal";
export const RELATION_PRINCIPAL_ID = 50;
export const RELATION_CHILDREN_ID = 49;
export const RELATION_SPOUSE = 48;
export const PRINCIPAL_NONE = 0;
export const TODAY = new Date();
export const MARITAL_STATUS_MARRIED = "Married";
export const MARITAL_STATUS_MARRIED_ID = 20;
export const REDIRECT_PAGE_MENU_ID = 3;
export const PRODUCT_TYPE_INDIVIDUAL = 182;
export const PRODUCT_TYPE_SME_ID = 183;
export const PRODUCT_TYPE_GROUP_ID = 184;
export const LINE_OF_BUSINESS_MEDICAL = 12;
export const TARIFF_CALCULATION_MANUAL = 167;

export const CURRENCY_AED = 1;

export const PRODUCT_TYPE_CODE_INDIVIDUAL = 101;
export const PRODUCT_TYPE_GROUP = 184;
export const PRODUCT_TYPE_SME = 102;
export const BENEFIT_DATATYPE_DROPDOWN = "ListofValues";
export const BENEFIT_USEREDIT_ALLOWED = "Y";
export const BENEFIT_USER_INTERACTIVE = "Y";
export const PRODUCT_TYPE_EBP_ID = 242;


export const RELATION_CATEGORY_PRINCIPAL_ID = 206;
export const RELATION_CATEGORY_DEPENDENTS_ID = 207;
export const BENEFIT_TYPE_VISA_REGION = 8;
export const BENEFIT_TYPE_NETWORK = 9;
export const BENEFIT_TYPE_OP_CO_INSURANCE = 10;
export const BENEFIT_TYPE_PHAR_CO_INSURANCE = 11;
export const BENEFIT_TYPE_AGGREGATE_LIMIT = 12;
export const BENEFIT_TYPE_GEOGRAPHICAL_SCOPE = 13;
export const BENEFIT_TYPE_DEDUCTIBLE = 14;
export const BENEFIT_TYPE_DENTAL = 57;
export const BENEFIT_TYPE_OPTICAL = 58;
export const BENEFIT_TYPE_MATERNITY = 59;
export const BENEFIT_TYPE_REMARKS = 65;

export const BENEFIT_PROPERTY_ID_VISA_REGION = 1;
export const BENEFIT_PROPERTY_ID_NETWORK = 2;
export const BENEFIT_PROPERTY_ID_CO_INSURANCE = 3;
export const BENEFIT_PROPERTY_ID_DENTAL = 4;
export const BENEFIT_PROPERTY_ID_OPTICAL = 5;
export const BENEFIT_PROPERTY_ID_PHAR_CO_PAY = 6;
export const BENEFIT_PROPERTY_ID_REMARKS = 78;

export const COUNTRY_UNITED_ARAB_EMIRATES = 182;

export const STAGE_ACTION_STATUS_DOCUMENT_TYPE_NEW_POLICY = 8;

export const OUTSTANDING_CLAIMS_NAME = "outstandingClaim"
export const IBNR_NAME = "ibnr"

export const UNAUTHORIZZED_ERROR = 'Error 401 {"message":"Unauthorized"}';

/*for endorsement modules*/
export const VIEW_MODE = "View"
export const EDIT_MODE = "Edit"
export const ENDORSEMENT_MODULE = "EndorsementModule"
export const POLICY_MODULE = "PolicyModule"
export const QUOTATION_MODULE = "QuotationModule"
export const INDIVIDUAL_QUOTATION_MODULE = "IndividualQuotationModule"
export const GROUP_QUOTATION_MODULE = "GroupQuotationModule"
export const ENDORSEMENT_TYPE_GENERAL_ENDORSEMENT = 1
export const ENDORSEMENT_TYPE_EXTENSION_OF_PERIOD = 2
export const ENDORSEMENT_TYPE_ADDITION_OF_MEMBER = 3
export const ENDORSEMENT_TYPE_DELETION_OF_MEMBER = 4
export const ENDORSEMENT_TYPE_CANCELLATION = 5
export const ENDORSEMENT_TYPE_CHANGING_MEMBER_CATEGORY_UPGRADE = 6
export const ENDORSEMENT_TYPE_DOB_CHANGE = 7
export const ENDORSEMENT_TYPE_ADDITION_OF_CATEGORY = 8
export const ENDORSEMENT_TYPE_MARITAL_STATUS_CHANGE = 9
export const ENDORSEMENT_TYPE_CHANGE_IN_BROKERAGE = 10
export const ENDORSEMENT_TYPE_PREMIUM_CHARGES_ADJUSTMENT_ADDITION = 11
export const ENDORSEMENT_TYPE_CHANGING_MEMBER_CATEGORY_DOWN = 12
export const ENDORSEMENT_TYPE_CHANGE_OF_CLIENT = 13
export const ENDORSEMENT_TYPE_CHANGE_IN_POLICY_PERIOD = 14
export const ENDORSEMENT_TYPE_PREMIUM_CHARGES_ADJUSTMENT_REFUND = 15
export const ENDORSEMENT_TYPE_INITIAL = 16
export const ENDORSEMENT_TYPE_ADDITION_SUBGROUP = 57
export const ENDORSEMENT_TYPE_CHANGE_OF_AGENT = 97
export const ENDORSEMENT_TYPE_MEMBER_REINSTATE = 36


export const ENDORSEMENT_OPERATION_MODE_TECHNICAL = 177
export const ENDORSEMENT_OPERATION_MODE__NON_TECHNICAL = 178


export const SECTION_ONE = 1;
export const SECTION_TWO = 2;
export const SECTION_THREE = 3;
export const DHA_VERIFICATION = "DHA"
export const DOH_VERIFICATION = "DohVerify"
export const SHAFAFIYA_VERIFICATION = "Shafafiya"
export const COC_VERIFICATION = "COCVerify"
export const ICP_VERIFICATION = "ICP"


export const VERIFICATION_SOURCE_QUOTATION = "Q"
export const VERIFICATION_SOURCE_POLICY = "P"
export const VERIFICATION_SOURCE_ENDORSEMENT = "E"

export const DHA_BATCH = "DhaBatch"
export const DOH_BATCH = "DohBatch"

//Chart Map
export const SYSTEM_ID_MEDICAL_CORE_ID = 3;
export const SYSTEM_ID_MEDICAL_CORE_TEXT = 'MEDICAL CORE';

export const SYSTEM_ID_SECURITY = 2;
export const SYSTEM_ID_MEDICAL_SECURITY_TEXT = 'SECUIRTY';
export const IS_ZERO = 0;
export const IS_ONE = 1;
export const PAYMENT_MODE_CASH = 245;
export const PAYMENT_MODE_ONLINE_PAYMENT = 246;
export const INSTALLMENT_TYPE_CUSTOM = 268;

export const GROUP_QUOTATION_CENSUS_TEMPLATE = 1;

/*To differentiate B/W Portals*/
export const PORTALTYPE_CORE = "B2C";

// FOR REPORTS MENU LINK
export const PAGE_MENU_ID_INDIVIDUAL_QUOTATION_SEARCH = 3;
export const PAGE_MENU_ID_INDIVIDUAL_QUOTATION_MEMBER = 4;
export const PAGE_MENU_ID_INDIVIDUAL_QUOTATION_MAF = 5;
export const PAGE_MENU_ID_INDIVIDUAL_QUOTATION_SUMMARY = 6;
export const PAGE_MENU_ID_GROUP_QUOTATION_SEARCH = 94;
export const PAGE_MENU_ID_GROUP_QUOTATION_CENSUS_DATA = 95;
export const PAGE_MENU_ID_GROUP_QUOTATION_BENEFIT_STRUCTURE = 96;
export const PAGE_MENU_ID_GROUP_QUOTATION_SUMMARY = 98;
export const PAGE_MENU_ID_GROUP_QUOTATION_CONFIRMATION = 217;
export const PAGE_MENU_ID_POLICY_SEARCH = 7;
export const PAGE_MENU_ID_POLICY_MEMBERS = 8;
export const PAGE_MENU_ID_POLICY_SUMMARY = 9;
export const PAGE_MENU_ID_ENDORSEMENT_SEARCH = 100;
export const PAGE_MENU_ID_ENDORSEMENT_MEMBERS = 101;
export const PAGE_MENU_ID_ENDORSEMENT_SUMMARY = 102;
export const PAGE_MENU_ID_CLAIMS_REIMBURSEMENT = 159;
export const PAGE_MENU_ID_CLAIMS_SETTLEMENT = 157;
export const PAGE_MENU_ID_GROUP_RENEWAL_SEARCH = 394;

export const MODULE_ID_INDIVIDUAL_QUOTATION = 1;
export const MODULE_ID_GROUP_QUOTATION = 2;
export const MODULE_ID_POLICY = 42;
export const MODULE_ID_ENDORSEMENT = 3;
export const MODULE_ID_CLAIMS = 22;


export const CHARGE_APPLY_TYPE_MANUAL = 165;
export const CHARGE_APPLY_TYPE_AUTOMATIC = 164;

export const ACTION_BUTTON_PAGE_MENU_ID = 219;


export const QUOTE_REFERRAL_STATUS_INCOMPLETE = "Incomplete";
export const QUOTE_REFERRAL_STATUS_CLEAN = "Clean";
export const QUOTE_REFERRAL_STATUS_REFERRAL = "Referral";

/*Dropdown Masters */
export const MEMBER_ID_FIELDS = 71
export const OPERATOR_ID = 72

export const PAGE_MENU_ID_VERIFICATION = 154;

export const MODULE_ID_INTEGRATIONS = 304;
export const LOB_UNITED_HELATH_CARE = 11;

export const INTEGRATION_SOURCE_NAS_UPLOAD = "NasUpload";


export const APPLIED_ON_NUMBER_OF_MEMBERS = 338;
export const APPLIED_ON_FIXED_AMOUNT = 337;

export const MEMBER_PREMIUM_ENDORSEMENTS = [3, 4, 6, 7, 9, 11, 12, 15, 36];
export const SALARY_BAND_TYPE_LSB = 502;
export const SALARY_BAND_TYPE_HSB = 501;


export const ACCOUNT_TYPE_ID_MISC_AGENT = 1;
export const ACCOUNT_TYPE_ID_COMM_AGENT = 2;
export const ACCOUNT_TYPE_ID_MISC_BROKER = 3;
export const ACCOUNT_TYPE_ID_COMM_BROKER = 4;
export const ACCOUNT_TYPE_ID_CASH_DIRECT = 5;
export const ACCOUNT_TYPE_ID_GENERAL = 6;

export const COC_VERIFICATION_BY_TYPE_EID = "EID";
export const COC_VERIFICATION_BY_TYPE_UID = "UID";


export const DHA_MEMBER_TYPE_NEW_BORN = 44;
export const TPA_ID_NAS = 4;

export const HAAD_EMIRATES_NAME = ['Abu Dhabi', 'Al Ain'];

export const ADMIN_LOADING = 217;
export const TPA_LOADING = 215;
export const BROKER_LOADING = 216;
export const UW_LOADING = 375;
export const ADJUSTED_UW_LOADING = 571;

export const VISA_EMIRATE_BAHRAIN = 600;
export const VISA_EMIRATE_GULF1 = 743;
export const VISA_EMIRATE_GULF2 = 450;
export const VISA_EMIRATE_JORDAN = 603;
export const VISA_EMIRATE_KUWAIT = 210;
export const VISA_EMIRATE_LEBANON = 601;
export const VISA_EMIRATE_OMAN = 602;
export const VISA_EMIRATE_QATAR = 211;

export const VISA_EMIRATE_COUNTRY = [
    VISA_EMIRATE_BAHRAIN,
    VISA_EMIRATE_GULF1,
    VISA_EMIRATE_GULF2,
    VISA_EMIRATE_JORDAN,
    VISA_EMIRATE_KUWAIT,
    VISA_EMIRATE_LEBANON,
    VISA_EMIRATE_OMAN,
    VISA_EMIRATE_QATAR
];


export const SECTION_INDICATIVE_QUOTE = "IndicativeQuote";
export const SECTION_NORMAL_QUOTE = "NormalQuote";
export const PAGE_MENU_ID_INDICATIVE_QUOTE = 297;
/* Product Selection Starts */
export const PORTAL_PLAN_TYPE_ID_EXECUTIVE_PLANS = 295;
export const PORTAL_PLAN_TYPE_ID_STANDARD_PLANS = 296;
export const PORTAL_PLAN_TYPE_ID_BASIC_PLANS = 299;
export const PORTAL_PLAN_TYPE_ID_ESSENTIAL_PLANS = 298;
export const PORTAL_PLAN_TYPE_ID_LIMITED_PLANS = 297;
/* Product Selection  Ends */

export const TOB_TYPE_TOB = 494;

export const INSURED_TYPE_COMP = 4;
export const INSURED_TYPE_IND = 5;
export const VISA_TYPE_SELF_DEP = 143;
export const VISA_TYPE_DOMESTIC = 281;
export const VISA_TYPE_INVESTER = 141;

export const KYC_REPORT_ID = 3000;
export const KYC_REPORT_PARAM_ID = 4000;
export const NE_BASIC_PRODUCT_ID = 41;
export const NE_BASIC_ESS_PRODUCT_ID = 43;
export const NE_BASIC_NEXTCARE_PRODUCT_ID = 210;
export const NE_BASIC_ESS_NEXTCARE_PRODUCT_ID = 213;
export const MAX_ALLOWED_AGE = 70;
/**********************************************************COMPLAINTS AND FEEDBACK *******************************************************************/

export const SYSTEM_COMPLAINTS_ID = 9;
export const SYSTEM_MENU_COMPLAINTS_ID = 20000;

export const MODULE_ID_COMPLAINTS = 143;
export const PAGE_MENU_ID_COMPLAINTS_DETAILS = 20001;
export const PAGE_MENU_ID_COMPLAINTS_REPORTS = 20001;
export const DUPLICATE_YES = 'Yes';
/***********LOB***********************/
export const  LOP_TYPE_MEDICAL = 2;
export const  LOP_TYPE_MOTOR = 1;
export const  LOP_TYPE_GENERAL = 3;

/***********SUB LOB***********************/
export const  SUB_LOB_TYPE_MOTOR_UNDERWRITING = 1;
export const  SUB_LOB_TYPE_MOTOR_CLAIM = 2;
export const  SUB_LOB_TYPE_ROAD_ASSISTANCE = 3;
export const  SUB_LOB_TYPE_HIRE_CAR_BENEFIT = 4;
export const  SUB_LOB_TYPE_WORKSHOP = 5;
export const  SUB_LOB_TYPE_MEDICAL_UNDERWRITING = 6;
export const  SUB_LOB_TYPE_MEDICAL_CLAIM = 7;
export const  SUB_LOB_TYPE_GENERAL_UNDERWRITING = 8;
export const  SUB_LOB_TYPE_GENERAL_CLAIM = 9;

/***********SOURCE***********************/
export const  SOURCE_WEBSITE = 2;
export const  SOURCE_EMAIL = 3;
export const  SOURCE_PHONE = 4;
export const  SOURCE_WALKIN = 5;
export const  SOURCE_CENTRAL_BANK = 6;
export const  SOURCE_DHA = 7;
export const  SOURCE_DOH = 8;

/***********STATUS***********************/
export const  STATUS_OPEN = 1;
export const  STATUS_PENDING = 2;
export const  STATUS_CLOSE = 3;

/***********COMPLAINT RESULT***********************/
export const  COMPLAINT_RESULT_JUSTIFIED = 930;
export const  COMPLAINT_RESULT_UNJUSTIFIED = 931;

export const  MOTOR_LOB_MASTER = 1;
export const  MEDICAL_LOB_MASTER = 2;
export const  CAPTCHA_SITE_KEY = "6LcOB9wqAAAAAIie4NBSGF_TblLat3kEhxHRZcEj";

export const DOMAIN_SALUTATION_MS_COMPANY = 267;

export const ENTITY_TYPE_DOMAIN_ID_CITIZEN = 63;
export const ENTITY_TYPE_DOMAIN_ID_ESTABLISHMENT = 64;
export const ENTITY_TYPE_DOMAIN_ID_PROPERTY_OWNER = 65;
export const ENTITY_TYPE_DOMAIN_ID_RESIDENT = 66;



export const COMM_PRODUCT_TYPE_MOTOR=982;
export const COMM_SERVICE_TYPE_MOTOR_NEW_INSURANCE=2;
export const COMM_SERVICE_TYPE_MOTOR_RENEWAL=3;